import { Injectable } from '@angular/core';
import { Moment } from 'moment';

@Injectable()
export class CharterBuyflowSessionService {
  public chosenMoment: Moment;
  public chosenWaterBodyId: number;
}
